import React, { useEffect, useRef, useState } from "react"
import { Formik, Form, Field, FieldArray, useField, } from "formik"
import Button from "react-bootstrap/Button"
import "./NurseNotes.scss"
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import RenderSummaryHeader from "../../../SummaryView/components/RenderSummaryHeader/RenderSummaryHeader"
import DateFnsUtils from "@date-io/date-fns"
import TextField from '@mui/material/TextField'
import Toast from "../../../Toast"
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import Select from "react-select"
import {
  getAllWondersoftDrugs,
  getSaveNurseNotes,
  saveNurseNotes,
  getServiceBasedOnCategory,
  getAllStaffDetail
} from "../../../../core/services/api"
import Multiselect from "multiselect-react-dropdown"
import dayjs from "dayjs"
import { useSelector } from "react-redux"
import Print from "components/Print/Print"
import NursingNotesPrint from "./NursingNotesPrint/NursingNotesPrint"

const tempValuesDropdown: any = [];
var mockInitialValues = {
  nurseTreatment: [
    {
      treatmentOrder: "",
      medicineAdministration: "",
      others: "",
      timeStartTreatment: dayjs(),
      timeFinishTreatment: dayjs(),
      timeError: false
    },
  ],

  vitals: [
    {
      vitalCaptureDate: dayjs(),
      bpDiastolic: "",
      bpSystolic: "",
      height: "",
      weight: "",
      bsa: "",
      bmi: "",
      temperature: "",
      pulseInfo: "",
      spo2: "",
      respirationRate: "",
      hemoglobin: "",
      wbcCount: "",
      plateletsCount: "",
      anc: "",
      serumCreatinine: "",
      totalBilirubinDirect: "",
      sgot: "",
      sgpt: "",
      totalProtein: "",
      hgt: "",
      egfr: "",
      serumBilirubinDirect: "",
      salbumin: "",
      scalcium: "",
    },
  ],
  servicesRendered: [
    {
      serviceTemplateId: "",
      serviceTemplateName: "",
      medicine: [],
      completedBy: "",
    },
  ],
  notes: "",
  nurseAcknowledgement: false,
  completedById: "",
  completedByName: "",
  status: "",
  isEditable: true
}

export const NursingForm = ({
  patientDetail,
  appointmentId,
  allOrder,
  isEdit,
  smartSummaryData,
  pastNotes,
  readOnly
}: any) => {
  const objectStyleTrue = {
    display: "block",
  }
  const objectStyleFalse = {
    display: "none",
  }

  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [initialValues, setInitialValues] = useState(mockInitialValues);
  const centerId = userDetail?.currentCenter?.centerId
  const [treatmentType, setTreatmentType] = useState([])
  const [displayToast, toggleDisplayToast] = useState<any>()

  //Select option Disable
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const isOptionDisabled = (option: any) => {
    return selectedOptions.some((selectedOption: any) => selectedOption === option.value);
  };

  const deleteSelectedOptions = (index: any) => {
    const newArray = [...selectedOptions];
    newArray.splice(index, 1)
    setSelectedOptions(newArray);
  }

  const componentRef: any = useRef<any>(null);

  useEffect(() => {
    if (pastNotes) {
      if (allOrder?.status === "SUBMITTED") {
        delete allOrder["id"]
        delete allOrder["patientId"]
        delete allOrder["appointmentId"]
        setInitialValues(allOrder)
      }
    }
    else {
      getSaveNurseNotes(appointmentId)
        .then((res) => {
          if (res[0]?.status === "SAVED") {
            delete res[0].id
            delete res[0].patientId
            delete res[0].appointmentId
            setInitialValues(res[0])
            const savedSelectedMedicines = initialValues?.servicesRendered
              .map((item: any) => {
                return item?.serviceTemplateId
              })
            setSelectedOptions(savedSelectedMedicines);
          } else if (res[0]?.status === "SUBMITTED") {
            delete res[0].id
            delete res[0].patientId
            delete res[0].appointmentId
            setInitialValues(res[0])
            const savedSelectedMedicines = initialValues?.servicesRendered
              .map((item: any) => {
                return item?.serviceTemplateId
              })
            setSelectedOptions(savedSelectedMedicines);
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }, [])

  const [nurseNames, setNurseNames] = useState<any>()
  useEffect(() => {
    getServiceBasedOnCategory("IPD", userDetail?.currentCenter?.centerId)
      .then((res) => {
        setTreatmentType(res)
      })
      .catch((error) => {
        console.log(error)
      })

    getAllStaffDetail("NURSE", centerId, true).then((res) => {
      setNurseNames(res)
    }).catch((error: any) => {
      console.log(error);
    })
  }, [])

  var medicineDropdowns: any
  const [medicineDropdown, setmedicineDropdown] = useState<any>([])

  function medicineDetails(id: any) {
    getAllWondersoftDrugs(`?serviceTemplateId=${id}`)
      .then((res) => {
        medicineDropdowns = res.map((values: any) => {
          return values.brandName
        })
        setmedicineDropdown(medicineDropdowns);
      })
      .catch((error) => {
        console.log(error)
      })
  }


  const [dropdownTreatmentType, setDropdownTreatmentType] = useState<any>()
  useEffect(() => {
    const result = treatmentType.map((values: any) => {
      return {
        label: values?.name,
        value: values?.id,
      }
    })
    setDropdownTreatmentType(result);
  }, [treatmentType])



  const dropdownNurse = nurseNames?.map((values: any) => {
    return {
      label: values?.name,
      value: values?.id
    }
  })
  function onKeyDown(keyEvent: any) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
    }
  }

  const [nurseSignErr, setnurseSignErr] = useState<any>(false)
  const [completedByErr, setCompletedByErr] = useState<any>(false)

  const savingNurseNotes = (values: any, appointmentId: any) => {
    const isCompletedByValid = values.completedByName.length > 0;
    const isNurseSignValid = !!values.nurseAcknowledgement;
    const atLeastOneServiceRendered = values.servicesRendered.some(
      (service: any) => service.serviceTemplateId !== "" && service.serviceTemplateName !== ""
    );

    setCompletedByErr(!isCompletedByValid);
    setnurseSignErr(!isNurseSignValid);

    if (isCompletedByValid && isNurseSignValid && atLeastOneServiceRendered) {
      const updatedFormValues = { ...values };
      updatedFormValues.nurseTreatment?.forEach((v: any) => delete v["timeError"]);
      const {
        submittedDateTime,
        savedDateTime,
        isEditable,
        appointmentDate,
        ...modifiedFormValues
      } = updatedFormValues;

      delete modifiedFormValues["isInvoiceUpdatedOnSubmit"]
      saveNurseNotes(modifiedFormValues, appointmentId)
        .then((res) => {
          let toastMessage =
            modifiedFormValues.status === "SAVED"
              ? "Nurse Notes Saved Successfully"
              : "Nurse Notes Submitted Successfully";

          if (res?.status === "SUBMITTED") {
            if (!res?.isInvoiceUpdatedOnSubmit) {
              toastMessage += "\n Service details could not be sent to Front office Dept";
            }
          }

          toggleDisplayToast({ text: toastMessage, type: "success" });
          const temp: any = { ...modifiedFormValues }
          temp["isEditable"] = res?.isEditable

          setInitialValues({ ...temp })
        })
        .catch((error) => {
          toggleDisplayToast({ text: "Error in Saving Nurse Notes", type: "error" });
        });
    } else {
      if (!atLeastOneServiceRendered) {
        toggleDisplayToast({ text: "Please select at least one service", type: "error" });
      }
      if (!isCompletedByValid) {
        toggleDisplayToast({ text: "Please fill 'Completed By' field", type: "error" });
      }
      if (!isNurseSignValid) {
        toggleDisplayToast({ text: "Please fill mandatory 'Nurse Signature'", type: "error" });
      }
    }
  };

  const MyTextArea = ({ label, readOnly, ...props }: any) => {
    const [field, meta] = useField(props);
    return (
      <>
        <label htmlFor={props.id || props.name}>{label}</label>
        <textarea disabled={readOnly} className="text-area"
          {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </>
    );
  };

  return (
    <>
      <NursingNotesPrint
        componentRef={componentRef}
        patientDetail={patientDetail}
        smartSummaryData={smartSummaryData}
        treatments={initialValues?.nurseTreatment}
        vitals={initialValues?.vitals}
        servicesRendered={initialValues?.servicesRendered}
        nurseNotes={initialValues?.notes}
        completedBy={initialValues?.completedByName}
      />
      <div className="nurse-detail-wrapper">
        <div className="my-3">
          <Print
            componentRef={componentRef}
            buttonTitle='Print Nursing Notes'
            documentTitle="Nursing Notes"
          />
        </div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(values) => {
            const updatedValues = { ...values, status: "SUBMITTED" };
            savingNurseNotes(updatedValues, appointmentId);
          }}
        >
          {({ values, setFieldValue }) => (
            <LocalizationProvider dateAdapter={AdapterDateFns} utils={DateFnsUtils}>
              <Form autoComplete="off" onKeyDown={onKeyDown}>
                <FieldArray name="nurseTreatment">
                  {({ remove, push }) => (
                    <div>
                      <RenderSummaryHeader patientDetail={patientDetail} smartSummaryData={smartSummaryData} />
                      <div className="heading" style={{ marginTop: "50px" }}>
                        Treatment Plan
                      </div>
                      <div className="treatment-plan-table-heading">
                        <div className="treatment-label">Treatment Order</div>
                        <div className="treatment-label" style={{
                          marginLeft: "-30px"
                        }}>
                          Medicine Administration
                        </div>
                        <div className="treatment-label">
                          Time of Starting Treatment
                        </div>
                        <div className="treatment-label">
                          Time of Finishing Treatment
                        </div>
                        <div className="treatment-label">Others</div>
                      </div>
                      {values?.nurseTreatment?.length > 0 &&
                        values?.nurseTreatment?.map((nurseTreatment, index) => (
                          <>
                            <div className="treatment-plan-row" key={index}>
                              <Field
                                className="field-treatment-plan treatment-order"
                                name={`nurseTreatment.${index}.treatmentOrder`}
                                disabled={readOnly || !values?.isEditable}
                                style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                              />
                              <p className="print-only-treatment-order">{values?.nurseTreatment[index]?.treatmentOrder}</p>
                              <Field
                                className="field-treatment-plan"
                                name={`nurseTreatment.${index}.medicineAdministration`}
                                type="text"
                                disabled={readOnly || !values?.isEditable}
                                style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                              />

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="textfiled_time" style={{ display: 'flex', flexDirection: 'column' }}>
                                  <TimePicker
                                    label=""
                                    value={values.nurseTreatment[index].timeStartTreatment}
                                    disabled={readOnly || !values?.isEditable}
                                    onChange={(e: any) => {
                                      setFieldValue(
                                        `nurseTreatment.${index}.timeStartTreatment`,
                                        e
                                      )

                                    }} renderInput={(params) => <TextField disabled={readOnly || !values?.isEditable} {...params}
                                      variant="filled"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />}
                                  />
                                </div>
                              </LocalizationProvider>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="textfiled_time" style={{ display: 'flex', flexDirection: 'column' }}>
                                  <TimePicker
                                    label=""
                                    value={values.nurseTreatment[index].timeFinishTreatment}
                                    disabled={readOnly || !values?.isEditable}
                                    onChange={(e: any) => {
                                      setFieldValue(
                                        `nurseTreatment.${index}.timeFinishTreatment`,
                                        e
                                      )
                                      if (e < values.nurseTreatment[index].timeStartTreatment) {
                                        setFieldValue(
                                          `nurseTreatment.${index}.timeError`,
                                          true
                                        )
                                      }
                                      else {
                                        setFieldValue(
                                          `nurseTreatment.${index}.timeError`,
                                          false
                                        )
                                      }
                                    }} renderInput={(params) => <TextField disabled={readOnly || !values?.isEditable} {...params}
                                      variant="filled"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />}
                                  />
                                  {values.nurseTreatment[index].timeError === true ? (<span style={{ color: 'red', height: '20px', marginBottom: '30px' }} >Time Entered is less than start time</span>) : (<div></div>)}
                                </div>
                              </LocalizationProvider>
                              <Field
                                className="field-treatment-plan"
                                name={`nurseTreatment.${index}.others`}
                                type="text"
                                disabled={readOnly || !values?.isEditable}
                                style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                              />
                              {!readOnly && (
                                <button
                                  type="button"
                                  style={
                                    isEdit === "true"
                                      ? objectStyleTrue
                                      : isEdit === "none"
                                        ? objectStyleTrue
                                        : objectStyleFalse
                                  }
                                  className="delete-button"
                                  onClick={() => {
                                    if (values?.nurseTreatment?.length > 1) {
                                      remove(index)
                                    }
                                  }}
                                  disabled={!values?.isEditable || readOnly}
                                >
                                  <img
                                    src="../../assets/images/delete-icon.svg"
                                    alt=""
                                  />
                                </button>
                              )}
                            </div>
                          </>
                        ))}
                      {(
                        <button
                          type="button"
                          style={
                            isEdit === "true"
                              ? objectStyleTrue
                              : isEdit === "none"
                                ? objectStyleTrue
                                : objectStyleFalse
                          }
                          className="add-new-button-treat"
                          onClick={() =>
                            push({
                              treatmentOrder: "",
                              medicineAdministration: "",
                              timeStartTreatment: dayjs(),
                              timeFinishTreatment: dayjs(),
                              others: "",
                            })
                          }
                          disabled={!values?.isEditable || readOnly}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  )}
                </FieldArray>
                <div className="vitals-wrapper">
                  <FieldArray name="vitals">
                    {({ remove, push }) => (
                      <>
                        <div className="heading">Vitals</div>
                        {(
                          <button
                            type="button"
                            style={
                              isEdit === "true"
                                ? objectStyleTrue
                                : isEdit === "none"
                                  ? objectStyleTrue
                                  : objectStyleFalse
                            }
                            className="add-new-button"
                            onClick={() =>
                              push({
                                vitalCaptureDate: dayjs(),
                                bpDiastolic: "",
                                bpSystolic: "",
                                height: dayjs(),
                                weight: "",
                                bsa: "",
                                bmi: "",
                                temperature: "",
                                pulseInfo: "",
                                spo2: "",
                                hemoglobin: "",
                                wbcCount: "",
                                plateletsCount: "",
                                anc: "",
                                respirationRate: "",
                                serumCreatinine: "",
                                totalBilirubinDirect: "",
                                sgot: "",
                                sgpt: "",
                                totalProtein: "",
                                hgt: "",
                                egfr: "",
                                serumBilirubinDirect: "",
                                salbumin: "",
                                scalcium: "",
                              })
                            }
                            disabled={!values?.isEditable || readOnly}
                          >
                            Add
                          </button>
                        )
                        }
                        <div className="vital-table" style={{ display: "flex", flexDirection: "row" }}>
                          <div className="vital-plan-table-heading">
                            <div className="vital-label">Date</div>
                            <div className="vital-label">Time</div>
                            <div className="vital-label">Temperature</div>
                            <div className="vital-label">BP Systolic</div>
                            <div className="vital-label">BP Diastolic</div>
                            <div className="vital-label">Pulse</div>
                            <div className="vital-label">SPO2</div>
                            <div className="vital-label">Resp</div>
                          </div>
                          {values?.vitals?.length > 0 &&
                            values?.vitals?.map((vitals, index) => (
                              <>
                                <div className="vital-plan-row" key={index}>
                                  <LocalizationProvider dateAdapter={AdapterDateFns} utils={DateFnsUtils}>
                                    <DatePicker
                                      inputFormat="dd/MM/yyyy"
                                      value={values.vitals[index].vitalCaptureDate}
                                      onChange={(value) =>
                                        setFieldValue(`vitals.${index}.vitalCaptureDate`, value)
                                      }
                                      renderInput={(params) => (
                                        <TextField {...params} variant="standard" id="date-picker-dialog"
                                          className="field-vital"
                                          style={{
                                            width: '150px',
                                            backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "white",
                                            marginTop: "15px",
                                            border: "none"
                                          }} />
                                      )}
                                    />
                                  </LocalizationProvider>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <TimePicker
                                      label=""
                                      value={values.vitals[index].height}
                                      onChange={(e: any) => {
                                        setFieldValue(
                                          `vitals.${index}.height`,
                                          e
                                        )

                                      }} renderInput={(params) => <TextField {...params}
                                        variant="filled"
                                        style={{ width: "150px" }} className="textfiled_time_vitals"
                                      />}
                                      disabled={readOnly || !values?.isEditable}
                                    />
                                  </LocalizationProvider>
                                  <Field
                                    className="field-vital"
                                    name={`vitals.${index}.temperature`}
                                    type="number"
                                    disabled={readOnly || !values?.isEditable}
                                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                                  />
                                  <Field
                                    className="field-vital"
                                    name={`vitals.${index}.bpSystolic`}
                                    type="number"
                                    disabled={readOnly || !values?.isEditable}
                                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                                  />
                                  <Field
                                    className="field-vital"
                                    name={`vitals.${index}.bpDiastolic`}
                                    type="number"
                                    disabled={readOnly || !values?.isEditable}
                                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                                  />
                                  <Field
                                    className="field-vital"
                                    name={`vitals.${index}.pulseInfo`}
                                    type="number"
                                    disabled={readOnly || !values?.isEditable}
                                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                                  />
                                  <Field
                                    className="field-vital"
                                    name={`vitals.${index}.spo2`}
                                    type="number"
                                    disabled={readOnly || !values?.isEditable}
                                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                                  />
                                  <Field
                                    className="field-vital"
                                    name={`vitals.${index}.respirationRate`}
                                    type="number"
                                    disabled={readOnly || !values?.isEditable}
                                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                                  />
                                  {!readOnly && (
                                    <button
                                      type="button"
                                      style={
                                        isEdit === "true"
                                          ? objectStyleTrue
                                          : isEdit === "none"
                                            ? objectStyleTrue
                                            : objectStyleFalse
                                      }
                                      className="delete-button"
                                      onClick={() => {
                                        if (values?.vitals?.length > 1) {
                                          remove(index)
                                        }
                                      }}
                                      disabled={!values?.isEditable || readOnly}
                                    >
                                      <img
                                        src="../../assets/images/delete-icon.svg"
                                        alt=""
                                      />
                                    </button>
                                  )}
                                </div>
                              </>
                            ))}
                        </div>
                      </>
                    )}
                  </FieldArray>
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <div className="heading" style={{ marginBottom: "5px", marginTop: '10px' }}>
                    Nursing Notes
                  </div>
                  <p className="print-only">{values?.notes}</p>
                  <MyTextArea
                    className="common-widths"
                    name={`notes`}
                    rows="6"
                    placeholder=""
                    readOnly={readOnly || !values?.isEditable}
                    style={{ backgroundColor: (readOnly || !values?.isEditable) ? "#ededed" : "" }}
                  />
                </div>
                <div className="services-rendered">
                  <div style={{ display: "flex" }}>
                    <div style={{ color: 'red' }}>*</div>
                    <div className="heading" style={{ marginBottom: "20px" }}>
                      Services Rendered
                    </div>
                  </div>
                  <div className="service-row">
                    <div className="dynamic-col">
                      <div className="treatment-plan-table-heading">
                        <div className="services-label">Type</div>
                        <div className="services-label">Medicine</div>
                        {/* <div className="services-label">Completed By</div> */}
                      </div>
                      <FieldArray name="servicesRendered">
                        {({ remove, push }) => (
                          <div className="dynamic-input">
                            {values?.servicesRendered?.length > 0 &&
                              values?.servicesRendered?.map(
                                (servicesRendered, index) => (
                                  <div
                                    className="table-row-dynamic"
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                    key={index}
                                  >
                                    <div className="service-render-common">
                                      <div className="custom-react-select-nurse">
                                        <Select
                                          styles={{
                                            control: (provided, state) => ({
                                              ...provided,
                                              border: "1px solid #ccd0e7",
                                              borderRadius: "10px"
                                            })
                                          }}
                                          className="select-Nurse"
                                          defaultValue={{
                                            label: "",
                                            value: ""
                                          }}
                                          onChange={(data: any) => {
                                            const newArray = [...selectedOptions];
                                            newArray[index] = data?.value;
                                            setSelectedOptions(newArray);
                                            setFieldValue(`servicesRendered.${index}.serviceTemplateName`, data?.label);
                                            setFieldValue(`servicesRendered.${index}.serviceTemplateId`, data?.value);
                                            setFieldValue(
                                              `servicesRendered.${index}.medicine`,
                                              []
                                            )
                                            tempValuesDropdown.push(data?.label);
                                            medicineDetails(data?.value);
                                          }}
                                          value={{
                                            label: values.servicesRendered[index].serviceTemplateName,
                                            value: "",
                                          }}
                                          options={dropdownTreatmentType
                                          }
                                          isOptionDisabled={isOptionDisabled}
                                          isDisabled={readOnly || !values?.isEditable}
                                        />
                                      </div>
                                    </div>
                                    <div className="service-render-common">
                                      <div onFocus={() => {
                                        medicineDetails(values?.servicesRendered[index]?.serviceTemplateId);
                                      }}>
                                        <Multiselect
                                          isObject={false}
                                          options={medicineDropdown}
                                          selectedValues={
                                            values?.servicesRendered[index]?.medicine
                                          }
                                          placeholder={values?.servicesRendered[index]?.medicine?.length == 0 ? "Select" : ""}
                                          onSelect={(data) => {
                                            if (data.length > 0) {
                                              setFieldValue(
                                                `servicesRendered.${index}.medicine`,
                                                data
                                              )
                                            } else {
                                              setFieldValue(
                                                `servicesRendered.${index}.medicine`,
                                                []
                                              )
                                            }
                                          }}
                                          disable={readOnly || !values?.isEditable}
                                        ></Multiselect>
                                      </div>
                                    </div>
                                    {!readOnly && (
                                      <button
                                        style={
                                          isEdit === "true"
                                            ? objectStyleTrue
                                            : isEdit === "none"
                                              ? objectStyleTrue
                                              : objectStyleFalse
                                        }
                                        type="button"
                                        className="delete-button"
                                        onClick={() => {
                                          deleteSelectedOptions(index);
                                          if (values?.servicesRendered?.length > 1) {
                                            remove(index)
                                          }
                                        }}
                                        disabled={!values?.isEditable || readOnly}
                                      >
                                        <img
                                          src="../../assets/images/delete-icon.svg"
                                          alt=""
                                        />
                                      </button>
                                    )}
                                  </div>
                                ))}
                            {(
                              <button
                                type="button"
                                style={
                                  isEdit === "true"
                                    ? objectStyleTrue
                                    : isEdit === "none"
                                      ? objectStyleTrue
                                      : objectStyleFalse
                                }
                                className="add-new-button-treat"
                                onClick={() =>
                                  push({
                                    serviceTemplateName: "",
                                    medicine: [],
                                    completedBy: "",
                                  })
                                }
                                disabled={!values?.isEditable || readOnly}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                  <div className="Nursing">
                    < div className="nurse-signs-wrapper">
                      <div className="nurse_acknowledge">
                        <div className="nurse_label_wrapper">
                          <div className="heading">
                            Nursing Sign
                          </div>
                          {nurseSignErr ? <div></div> : <div style={{ color: 'red' }}>*</div>}
                        </div>
                        <div className="nurse-check">
                          <Field type="checkbox" name="nurseAcknowledgement" disabled={readOnly || !values?.isEditable} />
                          <span className="nurseSign">
                            I confirm that the above information is true to the best
                            of my knowledge and belief.
                          </span>
                        </div>
                      </div>
                      <div className="nurse_completed">
                        <div className="heading" style={{ display: "flex" }}>
                          {completedByErr ? <div></div> : <div className="err" style={{ color: 'red' }}>*</div>}
                          Completed By
                        </div>
                        <Select
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              border: "1px solid #ccd0e7",
                              borderRadius: "10px"
                            })
                          }}
                          className="select-Nurse"
                          onChange={(data: any) => {

                            setFieldValue(
                              `completedById`,
                              data.value
                            )
                            setFieldValue(
                              `completedByName`,
                              data.label
                            )
                          }}
                          value={{
                            label: values?.completedByName,
                            value: values?.completedById,
                          }}
                          options={dropdownNurse}
                          isDisabled={readOnly || !values?.isEditable}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {!readOnly && (
                  <div className="save-submit-row">
                    <Button
                      variant="primary"
                      style={
                        isEdit === "true"
                          ? objectStyleTrue
                          : isEdit === "none"
                            ? objectStyleTrue
                            : objectStyleFalse
                      }
                      className="submission-button"
                      onClick={() => {
                        values.status = "SAVED"
                        savingNurseNotes(values, appointmentId)
                      }}
                      disabled={!values?.isEditable || (values?.isEditable && values?.status === "SUBMITTED" && !pastNotes) || readOnly}
                    >
                      Save Notes
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="submission-button"
                      disabled={!values?.isEditable || readOnly}
                    >
                      Submit Notes
                    </Button>
                  </div>
                )}
              </Form>
            </LocalizationProvider>
          )}
        </Formik>
        {displayToast && (
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => {
              toggleDisplayToast(false)
            }}
            onCloseText="Close"
            onClickText={null}
          />
        )}
      </div>
    </>
  )
}

function NursingDetailWS({
  patientInfo, appointmentId, allOrder, isEdit, smartSummaryData, readOnly, pastNotes
}: any) {

  return (
    <>
      <NursingForm
        patientDetail={patientInfo}
        appointmentId={appointmentId}
        allOrder={allOrder}
        isEdit={isEdit}
        pastNotes={pastNotes}
        smartSummaryData={smartSummaryData}
        readOnly={readOnly}
      />
    </>
  )
}

export default NursingDetailWS
